const data = [
    {id: 1, link: '/', title: 'Home'},
    {id: 2, link: '/#about', title: 'About'},
    {id: 3, link: '/#portfolio', title: 'Programs'},    
    {id: 4, link: '/#services', title: 'Why Us?'},    
    {id: 5, link: '/#contact', title: 'Contact'},
    {id: 7, link: '/blog', title: 'Blog'},
    {
        id: 6, 
        title: 'Training & Internship',
        submenu: [
            {
                id: 61, 
                link: '/virtual-internship/data-science', 
                title: 'Data Science'
            },
            {
                id: 62,
                link: '/virtual-internship/data-analytics',
                title: 'Data Analytics'
            },
            {
                id: 63,
                link: '/virtual-internship/data-engineering',
                title: 'Data Engineering'
            },
        ]
    },
]

export default data;